<script>
import { Doughnut, mixins } from "vue-chartjs";
import _ from "../../views/Utility/utility";
const { reactiveProp } = mixins;

export default {
    extends: Doughnut,
    mixins: [reactiveProp],
    props: {
        pieChartType: String,
        legend: Boolean,
        centerText: Number,
    },
    computed: {
        options() {
            return {
                responsive: true,
                maintainAspectRatio: true,
                tooltips: {
                    enabled: true,
                    titleFontSize: 14,
                    titleMarginBottom: 8,
                    bodyFontSize: 15,
                    bodySpacing: 10,
                    callbacks: {
                        label: (tooltipItems, data) => {
                            const index = tooltipItems.index;
                            return `${
                                this.chartData.labels[index]
                            } ${_.getMoneyFormat(
                                this.chartData.datasets[0].data[index]
                            )}`;
                        },
                    },
                    legendTemplate: "<h1>Hii</h1>",
                },
                legend: this.legend
                    ? {
                          position: "left",
                          align: "start",
                      }
                    : {
                          display: false,
                      },
                center: {
                    text: `${this.centerText}`,
                    color: "#FF6384", // Default is #000000
                    fontStyle: "Arial", // Default is Arial
                    sidePadding: 20, // Default is 20 (as a percentage)
                    minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                    lineHeight: 25, // Default is 25 (in px), used for when text wraps
                },
            };
        },
    },
    mounted() {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.renderChart(this.chartData, this.options);
    },
};
</script>